import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=7831dc57&scoped=true"
import script from "./GoodsList.vue?vue&type=script&lang=js"
export * from "./GoodsList.vue?vue&type=script&lang=js"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=7831dc57&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7831dc57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7831dc57')) {
      api.createRecord('7831dc57', component.options)
    } else {
      api.reload('7831dc57', component.options)
    }
    module.hot.accept("./GoodsList.vue?vue&type=template&id=7831dc57&scoped=true", function () {
      api.rerender('7831dc57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/goods/GoodsList.vue"
export default component.exports